<template>
  <span :class="`material-${iconType}s-outlined`" :style="style">
    {{ name }}
    <slot />
  </span>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  iconType: {
    type: String,
    default: 'icon',
    validator(value) {
      return ['icon', 'symbol'].includes(value)
    },
  },
  size: {
    type: String,
    default: '20px',
  },
  fill: {
    type: Boolean,
    default: false,
  }
})

const style = computed(() => {
  return {
    fontSize: props.size,
    fontVariationSettings: props.fill ? '\'FILL\' 1' : '',
  }
})
</script>